import Book from './Book';
import Page from './Page';

export { default as Book } from './Book';
export { default as Page } from './Page';

const models = [Book, Page];

export default models;
